export const WIZARD_REQUEST_TYPES = {
  houseDetailForm: 'house-detail-form',
  houseDetailGallery: 'house-detail-gallery',
  houseListForm: 'house-list-form',
  vendorDetailForm: 'vendor-detail-form',
  vendorDetailOfficesForm: 'vendor-detail-offices-form',
  catalogForm: 'catalog-form',
  outfitter: 'outfitter',
  houseDetailFavourite: 'house-wizard-item-favourite',
  houseDetailExpose: 'house-wizard-item-expose'
} as const

export type WizardRequestType = typeof WIZARD_REQUEST_TYPES[keyof typeof WIZARD_REQUEST_TYPES]

export const MAX_VENDORS_TO_REQUEST = 4
